/**
 * <Toolbar />
 *
 * - It is an entirely recreated custom toolbar for react-big-calendar.
 * - There are inputs that allow users to filter timetable.
 *
 * @parent react-big-calenar
 * @stateful
 * @redux
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import { browserHistory } from 'react-router'
// //
import { connect } from 'react-redux';
import { navigate } from 'vendor/react-big-calendar/utils/constants';
import { Form } from 'components/UI';
import SelectItemModal from 'template/Modals/SelectItem';

import FilterBy from 'template/FilterBy';

import AddLessonDock from 'template/Docks/AddLesson';

import getScheduleOption from './getScheduleOption';

import getTimetable from 'controllers/school/getTimetable'

import { setFilterData, SET_LOGGEDIN_TEACHER_ID } from './ducks';

import SelectTeacherModal from 'template/Modals/SelectTeacher';
import SelectClassModal from 'template/Modals/SelectClass';
import SelectClassroomModal from 'template/Modals/SelectClassroom';

import __R, { userCan } from 'containers/__R'

import {
  Button,
	Tab,
	Tabs,
	TabList,
	TabPanel
} from 'components/UI'

const DEFAULT_TAB_INDEX = 0;

const VIEWS = ['month', 'week', 'day'];

const FILTERS = ['classroom', 'class', 'teacher', 'student'];

const FILTERS_FOR_TEACHER = ['classroom', 'class'];

const mapStateToProps = state => ({
  schedule: state.schedule,
  user: state.user,
});

class Toolbar extends React.Component {
  static propTypes = {
  }

  constructor(props) {
    super(props);
    this._changeView = this._changeView.bind(this);
    this._onFilterChange = this._onFilterChange.bind(this);
    this._renderPrevNowNextButton = this._renderPrevNowNextButton.bind(this);

    this.displayFilteredData = this.displayFilteredData.bind(this);

    this.state = {
      filterData: {},
    }
    this.filterOptions = {
      classroom: {
        selectMultiple: true,
        disabled: !userCan('classroom_channel')
      },
      class: {
        selectMultiple: true,
        disabled: !userCan('class_channel') || !userCan('private_class_channel')
      },
      teacher: {
        selectMultiple: true,
        disabled: !userCan('teacher_channel')
    
      },
      student: {
        selectMultiple: false,
        disabled: !userCan('student_channel')
      },
    }
  }

  componentWillReceiveProps({user, date}){
    const {dispatch, schedule} = this.props;

    const { displayedDate } = this.state;

    if (displayedDate != date) {
      this.setState({
        displayedDate: date,
      }, ()=>{
        this.displayFilteredData();
      });
    }

    if(user.result && user.result.school_list){
      const schoolId = localStorage.getItem('schoolId')
      let currentSchool
      user.result.school_list.map((school) => {
        if(school.school_id == schoolId){
          currentSchool = school
        }
      })

      if(currentSchool&& schedule.loggedinTeacherId != currentSchool.school_teacher_id){
        if (currentSchool.school_teacher_id){
          dispatch({
            type: SET_LOGGEDIN_TEACHER_ID,
            loggedinTeacherId: currentSchool.school_teacher_id,
          })
        }
      }
    }

  }

  _changeView(tabIndex) {
    this.props.onViewChange(VIEWS[tabIndex]);
  }

  onNavigate(type) {
    const {
      onNavigate,
    } = this.props;

    onNavigate(type);
  }

  _onFilterChange({ filterData }) {
    this.setState({
      filterData,
    }, ()=>{
      this.displayFilteredData();
    });
  }

  displayFilteredData() {
    let { filterData } = this.state;

    let schoolId = localStorage.getItem('schoolId');

    if (filterData.student) {
      const schoolStudentID = filterData.student.IDs;

      const { displayedDate: date } = this.state;

      // a student is selected for filtering
      const scheduleOption = {
        ...getScheduleOption(date),
        // filter_type: 'filter_by_student',
        student_id: schoolStudentID,
      };

      getTimetable(schoolId, scheduleOption)
      .then(({ data })=>{
        filterData.student = {
          ...filterData.student,
          events: data.result_list,
        }

        this.props.dispatch(setFilterData(filterData))
      })
      .catch((error)=>{
        console.error(error)
      });
    } else if (filterData.teacher) {
      const teacherIDs = filterData.teacher.IDs
      const { displayedDate: date } = this.state;
      const scheduleOption = {
        ...getScheduleOption(date),
        // filter_type: 'filter_by_student',
        teacher_id: teacherIDs,
      };

      getTimetable(schoolId, scheduleOption)
      .then(({ data })=>{
        filterData.teacher = {
          ...filterData.teacher,
          events: data.result_list,
        }
        
        this.props.dispatch(setFilterData(filterData))
      })
      .catch((error)=>{
        console.error(error)
      });
    } else {
      this.props.dispatch(setFilterData(filterData))
    }
  }

  _renderPrevNowNextButton(changeDateType) {
    let {
      date,
    } = this.props;

    let prev;
    let now;
    let next;

    switch (changeDateType) {
      case 'month':
        prev = __("Previous Month", "schedule.calendar");
        next = __("Next Month", "schedule.calendar");
        break;
      case 'week':
        prev = __("Previous Week", "schedule.calendar");
        next = __("Next Week", "schedule.calendar");
        break;
      case 'day':
        prev = __("Yesterday", "schedule.calendar");
        next = __("Tomorrow", "schedule.calendar");
        break;
    }

    //
    // TODO: Refactor it
    //
    return (
      <span className='navigate-date'>
        <div
          className='change-date-button btn-link'
          onClick={()=>{
            this.onNavigate('PREV')
          }}
        >
          <i className='change-date-arrow fa icon-left-dir'></i>
          {prev}
        </div>
        <div
          className='change-date-button btn-link'
          onClick={()=>{
            this.onNavigate('TODAY')
          }}
        >
          {__("Today", "schedule.calendar")}
        </div>
        <div
          className='change-date-button btn-link'
          onClick={()=>{
            this.onNavigate('NEXT')
          }}
        >
          {next}
          <i className='change-date-arrow fa icon-right-dir'></i>
        </div>
      </span>
    );
  }

  render() {
    let {
      label,
      onNavigate,
    } = this.props;

    let {
      loggedinTeacherId,
    } = this.props.schedule;

    const {
      filterData,
    } = this.state;

    const schoolId = localStorage.getItem('schoolId');

    const Filter = <FilterBy
                      filterData={filterData}
                      selectMultiple={true}
                      filters={FILTERS}
                      options={this.filterOptions}
                      schoolId={schoolId}
                      onChange={this._onFilterChange} />

    return (
      <div className='classtop-rbc-toolbar'>
        <div className='date-label'>
          { label }
        </div>
        <Tabs defaultIndex={DEFAULT_TAB_INDEX} onSelect={this._changeView}>
          <TabList>
            <Tab>{__('month', 'schedule.calendar')}</Tab>
            <Tab>{__('week', 'schedule.calendar')}</Tab>
            <Tab>{__('day', 'schedule.calendar')}</Tab>
            <Button bsStyle='default' className="add-lesson pull-right"
              disabled={userCan('create_lesson') !== true && userCan('create_private_lesson') !== true}
              onClick={()=>{
                AddLessonDock({
                  disablePrivateClass: userCan('create_private_lesson') != true,
                  disableClass: userCan('create_lesson') != true,
                })
                .then((result)=>{
                  this.onNavigate('TODAY');
                });
              }}>
              <i className='fa icon-plus'></i> {__('Add Lesson', 'schedule')}
            </Button>
            <a href='/print-schedule' target='_blank' className='btn btn-primary pull-right'>
              {__('Print Schedule', 'schedule')}
            </a>
          </TabList>
          <TabPanel>
            {Filter}
            {this._renderPrevNowNextButton('month')}
          </TabPanel>

          <TabPanel>
            {Filter}
            {this._renderPrevNowNextButton('week')}
          </TabPanel>

          <TabPanel>
            {Filter}
            {this._renderPrevNowNextButton('day')}
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Toolbar);



// WEBPACK FOOTER //
// ./src/containers/pages/Schedule/Toolbar.js